import styled from '@emotion/styled'

export const Wrap = styled.section`
    display: flex;
    flex-direction: column;
    
    & > section {
        margin-bottom: 10px;
        margin-left: 5px;
    }
`;

export const Line = styled.div`
    display: flex;
    height: 48px;
    align-items: center;
    border: 1px solid #eee;
    padding-inline: 16px;
`;

export const LineItemText = styled.span`
    font-weight: bold;
    margin-right: 10px;
`;
